import React, { Component } from 'react'
import "./assets/css/general.css";
import Header from './components/Header';
import { Button, Typography } from '@mui/material';
import { connect } from 'react-redux';
import TileButton from './components/TileButton';
import { ROLES, setRole } from './redux/permissionSlice';
import { PermissionAreaComponent } from './hookInjection/PermissionAreaComponent';

import DefaultFrame from './components/DefaultFrame';
import { APIData } from './constants/APIAdresses';

class Dashboard extends Component {
    render() {
        const isInternalUser = this.props.role === ROLES.ADMIN;

        return (

            <DefaultFrame title="Dashboard">
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", marginTop: "2.5%" }}>
                    <TileButton path="/support" title="Support" iconSrc={require("./assets/icons/support.png")} />
                    <TileButton path="/conflicts" title="Konflikte" iconSrc={require("./assets/icons/customerservice.png")} />
                    <TileButton path="/users" title="Benutzerverwaltung" iconSrc={require("./assets/icons/team.png")} />
                    <TileButton path="/orders" title="Bestellverwaltung" iconSrc={require("./assets/icons/box.png")} />
                    <TileButton path="/partners" title="Partnermanagement" iconSrc={require("./assets/icons/store.png")} />
                    <TileButton path="/media" title="Mediamanagement" iconSrc={require("./assets/icons/photo-gallery.png")} />
                    <TileButton path="/data" title="Datenverwaltung" iconSrc={require("./assets/icons/dashboard.png")} />
                    {this.props.role === ROLES.ADMIN && <TileButton path="/logs" title="Logs" iconSrc={require("./assets/icons/terminal.png")} />}
                </div>
            </DefaultFrame>
        )
    }
}
function mapStateToProps(state) {
    return {
        role: state.permission.role
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setRole: (role) => {
            dispatch(setRole(role));
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
